<template>
  <div  class="home-center" v-if="imgList[0]">
    <el-dialog
      title=" "
      top="10vh"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="customRegister"
      :visible.sync="isShowIndexAD"
      @open="openQrCode"
      @close="closeQrCode"
      center
    >
        
        <div class="home-popBox-js">
        <span class="box" @click="CLOSE_INDEX_AD">
            <!-- <span class="iconfont icon-guanbi"></span> -->
            <i class="el-icon-close"></i>
            <!-- <i class="el-icon-close" 
            @click="CLOSE_INDEX_AD"></i> -->
        </span>
            
        <!-- <div class="home-popBox-header">
            <span class="title">
            {{imgList[0].imgName}}
            </span>
        </div> -->
        <a v-if="imgList[0] && imgList[0].imgLink &&imgList[0].imgClickLink" @click.prevent="adGoHref(imgList[0].imgClickLink)" href="#" target="_blank">
            <img :src="imgList[0].imgLink">
        </a>
        <img v-if="imgList[0] && imgList[0].imgLink && !imgList[0].imgClickLink" :src="imgList[0].imgLink">
        <!-- <div class="home-popBox-bottom">
            {{imgList[0].remark}}
            <button @click="CLOSE_INDEX_AD" class="close-btn-bottom">关闭</button>
        </div> -->
        </div>
    </el-dialog>
  </div>
</template>

<script>
/*eslint-disable*/
  import {mapMutations,mapState} from 'vuex'
  import {commonApi, common} from '@/common/index';
  import {PENDANT_HOME_CENTER} from '../../assets/js/bannerCode'

export default {
  name: 'home-center',
  data() {
    return {
      imgList: [],
      middleImgIndex: 0
    }
  },
  computed: {
    ...mapState({
      isShowIndexAD: state => state.isShowIndexAD,
    })
  },
  methods: {
    ...mapMutations([
      'CLOSE_INDEX_AD'
    ]),
    openQrCode(){
        this.$nextTick(() => {
            this.fetchImg()
        });
    },
    closeQrCode(){

    },
    fetchImg() {
      // jsPCPendantCenter
      let jsPCPendantCenter = commonApi.HOMEBEFORE.fetchImg(PENDANT_HOME_CENTER);

      Promise.all([jsPCPendantCenter])
        .then(data => {
          this.imgList = data[0];
        })
        .catch(err=>{
          this.imgList = []
        })
    },
    adGoHref(url) {
      let path =  common.goHref(url);
      if(path) {
        this.$router.push({path: path})
        this.CLOSE_INDEX_AD()
      }
    }
  },
  mounted() {
    this.fetchImg()
  }
};
</script>

<style scoped lang="scss">
//   @import '../../style/variable';
.home-center{
//   width:100vw;
//   height:100vh;
//   background-color: rgba($color: #000000, $alpha: .5);
//   position: fixed;
//   z-index:2200;
//   top: 0;
//   right:0;
//   left:0;
//   bottom: 0;
    .el-dialog {
        background-color: transparent !important;
    }
  .home-popBox-js{
    position: relative;width:730px;height:560px;
    margin:  0 auto;
    .box{
       position: absolute;
       border-radius: 50%;
       border:1px solid #cccccc;
       background-color: #fff;
       right:-30px;
       top: -30px;
       font-size:20px;
       font-weight: 400;
       color: #cccccc;
       cursor: pointer;
       z-index:0;
      width: 23px;
      height: 23px;
      padding-top: 2px;
       display: flex;
       justify-content: center;
       align-items: center;
       &:hover{
         .el-icon-close{
           color:#f43b5b;
         }
       }
    }
    .close-btn-bottom{cursor: pointer;border-radius: 4px;border: 1px solid #d3d3d3;outline: none;color: #555;font-family:'微软雅黑';
      position: absolute;top: 2px;right: 3px;background: #ffd800;width: 50px;height: 25px;
      &:hover{border-color: #999;color: #212121}
    }
    img{width:730px;height:560px;}
    .home-popBox-header{font-size: 13px;line-height: 30px;border-radius: 4px;border: 1px solid #aaa;width: 100%;min-height: 30px;background-color: #ccc;
      .title{color: #000;line-height: 28px;display: block;float: left;white-space: nowrap;width: 90%;overflow: hidden;text-overflow: ellipsis;font-family:'微软雅黑';
        span{font-weight: bold;}
      }
    }
    .home-popBox-bottom{
      margin-top: 5px;
      position: relative;
      color: #000;
      height: 30px;
      font-size: 12px;
      font-weight: bold;
      line-height: 29px;
      border-top: 1px solid #000;
      font-family:'微软雅黑'
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build902/components/pendant/home-center.vue